import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Input, Label } from "reactstrap";

export default function YesNoRadioSelector({ disabled = false, name, value, yesLabel = 'Yes', noLabel = 'No', onChange = () => {}, onBlur = () => {} }) {
  return (
    <FormGroup check className="custom-control custom-radio">
      <div className="custom-control custom-radio">
        <Input
          checked={value}
          className="custom-control-input"
          type="radio"
          name={name}
          id={`${name}Yes`}
          disabled={disabled}
          data-selector={`${name}Yes`}
          onChange={() => onChange({ target: { name, value: true } })}
        />{' '}
        <Label className="custom-control-label" htmlFor={`${name}Yes`}>{yesLabel}</Label>
      </div>
      <div className="custom-control custom-radio mb-medium">
        <Input
          checked={!value}
          className="custom-control-input"
          disabled={disabled}
          type="radio"
          name={name}
          id={`${name}No`}
          data-selector={`${name}No`}
          onChange={() => onChange({ target: { name, value: false } })}
        />{' '}
        <Label className="custom-control-label" htmlFor={`${name}No`}>{noLabel}</Label>
      </div>
    </FormGroup>
  );
}

YesNoRadioSelector.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  yesLabel: PropTypes.string,
  noLabel: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};
